<template>
  <div class="container">
    <div class="table-header">
      <h1>Customers</h1>
    </div>

    <!--MyTable :header="header" :data="filteredCustomers" :columns="header" @rowClicked="printRow"></MyTable>-->
    <Suspense>
      <template #default>
        <CustomersTable></CustomersTable>
      </template>
      <template #fallback>
        customers table still loading...
      </template>
    </Suspense>
    

    <FormBtn :name="'Create New Customer'" @clicked="createCustomer"></FormBtn>
  </div>
</template>

<script setup lang="ts">
import CustomersTable from './Customers-table.vue'
import FormBtn from '@/components/form/Form-btn.vue'
import router from '@/router'

function createCustomer() {
  router.push('/customers/create')
}
</script>
